import React from 'react';
import Banner from '../../Component/Banner/Banner';
import ContactMain from '../../Component/ContactSection/ContactMain';

import ScrollToTop from '../../Component/ScrollToTop/ScrollToTop';
import './Contact.scss';

function Contact() {
  return (
    <section className="contact" id="contact">
      <ScrollToTop/>
      <Banner />
      <ContactMain />
    </section>
  );
}

export default Contact;
